<template>
  <section class="content">
    <admin-header
      title="Documents"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:entity-quick-search="search"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:csv-upload="multiSave"
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminHeader from '../AdminHeader'
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  export default {
    name: 'AdminDocument',
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    data () {
      return {
        newEntityScreen: 'Admin - Documents',
        searchEntityScreen: 'Admin - Document search',
        filterEventName: 'admin-document-filter',
        filterName: 'DocumentFilter',
        entityName: 'document'
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// AdminDocument.vue?226d70fd